import { DOWNLOAD_WEIGHT_DISPUTE_ERROR_FAILURE, DOWNLOAD_WEIGHT_DISPUTE_ERROR_REQUEST, DOWNLOAD_WEIGHT_DISPUTE_ERROR_RESET, DOWNLOAD_WEIGHT_DISPUTE_ERROR_SUCCESS, } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const downloadErrorFileReducer = (state = initialState, action) => {
    switch (action.type) {
        case DOWNLOAD_WEIGHT_DISPUTE_ERROR_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case DOWNLOAD_WEIGHT_DISPUTE_ERROR_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, data: null, error: null });
        case DOWNLOAD_WEIGHT_DISPUTE_ERROR_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case DOWNLOAD_WEIGHT_DISPUTE_ERROR_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, data: null });
        default:
            return state;
    }
};
export default downloadErrorFileReducer;
